import { render, staticRenderFns } from "./Crisis_Committee_early.vue?vue&type=template&id=be1120f8"
import script from "./Crisis_Committee_early.vue?vue&type=script&lang=js"
export * from "./Crisis_Committee_early.vue?vue&type=script&lang=js"
import style0 from "./Crisis_Committee_early.vue?vue&type=style&index=0&id=be1120f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports